module.exports = __webpack_public_path__ + "static/media/2.eea3fc20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/2.svg
// module id = 126
// module chunks = 0